//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import constants from './../common/constants'

	export default {
		props: {
			data: {
				type: Array
			},
			error: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				swiperOption: {
					direction: 'vertical',
					slidesPerView: 'auto',
					freeMode: true,
					scrollbar: {
						el: '.swiper-scrollbar',
						hide: true,
						draggable: true
					},
					mousewheel: true,
					observer: true,
					observeParents: true
				}
			}
		},
		methods: {
			toInfo(type, code) {
				if (type == "2") {
					this.$router.push({
						path: '/finadetail/' + code
					})
				} else if (type == "1") {
					this.$router.push({
						path: '/funddetail/' + code
					})
				}
			},
			goRouter(type, code) {
				if (type == '2' && this.checkLogin != true) {
					// this.$router.push({ path: '/login', query: { to: '/finadetail/' + code } })
					this.goLogin('/login', '/finadetail/' + code)
				} else if (type == '2' && this.checkLogin == true) {
					this.$router.push({
						path: '/finadetail/' + code
					})
				} else {
					this.$router.push({
						path: '/funddetail/' + code
					})
				}
			}
		},
		filters: {
			addunit(value, unit) {
				if (value.indexOf('或') > -1) {
					return value.replace('或', unit + ' 或 ') + unit
				} else if (value.indexOf('~') > -1) {
					return value.replace('~', unit + ' ~ ') + unit
				} else if (value == '') {
					return '--'
				} else {
					return value + unit
				}
			}
		}
	}




// WEBPACK FOOTER //
// ./src/components/hotlist.vue